import React from 'react';
import { AdoptsModalType } from './constants';
import BuyerModalLoadable from './modals/BuyerModalLoadable';
import SellerModalLoadable from './modals/SellerModalLoadable';
import TransactionHistoryModalLoadable from './modals/TransactionHistoryModalLoadable';
import ResaleCountdownModalLoadable from './modals/ResaleCountdownModalLoadable';
export const adoptsModalRenderer = (modalType, requestClose, params)=>{
    switch(modalType){
        case AdoptsModalType.BUYER_MODAL:
            return /*#__PURE__*/ React.createElement(BuyerModalLoadable, {
                onRequestClose: requestClose,
                deviation: params.deviation,
                initialScreen: params.initialScreen
            });
        case AdoptsModalType.SELLER_MODAL:
            return /*#__PURE__*/ React.createElement(SellerModalLoadable, {
                onRequestClose: requestClose,
                deviation: params.deviation,
                initialScreen: params.initialScreen
            });
        case AdoptsModalType.TRANSACTION_HISTORY_MODAL:
            return /*#__PURE__*/ React.createElement(TransactionHistoryModalLoadable, {
                onRequestClose: requestClose,
                deviation: params.deviation
            });
        case AdoptsModalType.RESALE_WAIT_WINDOW_MODAL:
            return /*#__PURE__*/ React.createElement(ResaleCountdownModalLoadable, {
                onRequestClose: requestClose,
                deviation: params.deviation
            });
        default:
            return null;
    }
};
